import { __assign, __extends, __makeTemplateObject, __rest } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { nanoid } from 'nanoid';
import { fontStack } from '../utils/fontStack';
export * from './components/Tabs';
export * from './components/Tab';
export * from './components/TabPanels';
export * from './components/TabPanel';
var TabGroupComponent = /** @class */ (function (_super) {
    __extends(TabGroupComponent, _super);
    function TabGroupComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            current: _this.props.defaultValue || 0,
        };
        _this.onChange = function (idx) {
            var onChange = _this.props.onChange;
            _this.setState({ current: idx });
            if (onChange)
                onChange(idx);
        };
        return _this;
    }
    TabGroupComponent.prototype.render = function () {
        var _this = this;
        var _a = this.props, _b = _a.Component, Component = _b === void 0 ? 'div' : _b, label = _a.label, _c = _a.id, id = _c === void 0 ? nanoid() : _c, value = _a.value, defaultValue = _a.defaultValue, onChange = _a.onChange, children = _a.children, htmlAttributes = __rest(_a, ["Component", "label", "id", "value", "defaultValue", "onChange", "children"]);
        var current = this.state.current;
        return React.createElement(Component, __assign(__assign({}, htmlAttributes), { id: id, 'aria-label': label }), React.Children.map(children, function (child) {
            var element = child;
            if (React.isValidElement(element)) {
                element = React.cloneElement(element, {
                    groupId: id,
                    active: value !== undefined ? value : current,
                    onChange: value !== undefined ? onChange : _this.onChange,
                });
            }
            return element;
        }));
    };
    return TabGroupComponent;
}(React.Component));
export { TabGroupComponent };
export var TabGroup = styled(TabGroupComponent)(function () { return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n    flex-grow: 1;\n  "], ["\n    ", "\n    flex-grow: 1;\n  "])), fontStack); });
TabGroup.propTypes = {
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
    id: PropTypes.string,
    Component: PropTypes.elementType,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func,
    className: PropTypes.string,
    children: PropTypes.node,
};
var templateObject_1;
//# sourceMappingURL=TabGroup.js.map